import request from '@/utils/request'

// 采购计划相关接口
export function getPurchasePlanList(params) {
  return request({
    url: '/api/v1/purchasing-plan/list',
    method: 'POST',
    data: params
  })
}

export function createPurchasePlan(data) {
  return request({
    url: '/api/v1/purchasing-plan/save',
    method: 'post',
    data: {
      plan_name: data.planName,
      plan_no: data.planNo || '',
      status: data.status || 1,
      remark: data.remark || '',
      work_flow_id: data.workFlowId,
      negotiated_amount: data.negotiatedAmount || 0,
      department: data.department,
      category: data.category,
      priority: data.priority || 1
    }
  })
}

export function updatePurchasePlan(data) {
  return request({
    url: '/purchase/plan/update',
    method: 'put',
    data
  })
}

export function deletePurchasePlan(id) {
  return request({
    url: `/purchase/plan/delete/${id}`,
    method: 'delete'
  })
}

// 采购计划明细相关接口
export function getPlanDetailList(planId) {
  return request({
    url: `/purchase/plan/detail/${planId}`,
    method: 'get'
  })
}

export function addPlanDetail(data) {
  return request({
    url: '/purchase/plan/detail/add',
    method: 'post',
    data
  })
}

// 获取供应商列表
export function getSupplierList(params) {
  return request({
    url: '/supplier/list',
    method: 'get',
    params
  })
}

// 获取商品列表
export function getGoodsList(params) {
  return request({
    url: '/goods/list',
    method: 'get',
    params
  })
}

// 删除计划明细
export function deletePlanDetail(detailId) {
  return request({
    url: `/purchase/plan/detail/delete/${detailId}`,
    method: 'delete'
  })
}

// 提交审核
export function submitPlanForApproval(planId) {
  return request({
    url: `/purchase/plan/submit/${planId}`,
    method: 'post'
  })
}

// 获取采购计划审批流程
export function getPurchaseFlowHistory(planId) {
  return request({
    url: `/purchase/plan/flow/${planId}`,
    method: 'get'
  })
}

// 获取采购订单列表
export function getPurchaseOrderList(params) {
  return request({
    url: '/api/v1/purchasing-order/list',
    method: 'post',
    data:params
  })
}

// 添加提交审核接口
export function submitPurchaseOrder(orderId) {
  return request({
    url: '/api/v1/purchasing-order/submit',
    method: 'post',
    data: {
     "order_id": orderId
    }
  })
}

// 添加审核接口
export function approvePurchaseOrder(data) {
  return request({
    url: '/api/v1/purchasing-order/approve',
    method: 'post',
    data: data
  })
}

// 获取采购订单明细
export function getPurchaseOrderDetail(orderId) {
  return request({
    url: '/api/v1/purchasing-order/detail',
    method: 'post',
    data: {
      order_id: orderId
    }
  })
} 